class GetmanQuickAdd {
  static init() {

    document.addEventListener('toggle', GetmanQuickAdd.onToggle, true);
    document.addEventListener('click', GetmanQuickAdd.onDocumentClick);
    document.addEventListener('keydown', GetmanQuickAdd.onKeydown);
  }

  static onToggle(event) {
    const panel = event.target;
    if (!panel.classList || !panel.classList.contains('gm-product-card__quickadd')) return;

    if (panel.open) {
      document.querySelectorAll('.gm-product-card__quickadd[open]').forEach((other) => {
        if (other !== panel) other.removeAttribute('open');
      });

      GetmanQuickAdd.showColorStep(panel);

      const firstFocusable =
        panel.querySelector('.gm-color-swatch') ||
        panel.querySelector('.gm-size-swatch:not(.gm-size-swatch--hidden):not([disabled])');
      if (firstFocusable) firstFocusable.focus();
    }
  }

  static onDocumentClick(event) {
    const openPanel = document.querySelector('.gm-product-card__quickadd[open]');
    if (openPanel && !openPanel.contains(event.target)) {
      GetmanQuickAdd.closePanel(openPanel);
    }

    const backButton = event.target.closest('.gm-product-card__quickadd-back');
    if (backButton) {
      const panel = backButton.closest('.gm-product-card__quickadd');
      if (panel) GetmanQuickAdd.showColorStep(panel);
      return;
    }

    const colorButton = event.target.closest('.gm-color-swatch');
    if (colorButton) {
      const panel = colorButton.closest('.gm-product-card__quickadd');
      if (panel) GetmanQuickAdd.selectColor(colorButton, panel);
      return;
    }

    const sizeButton = event.target.closest('.gm-size-swatch');
    if (sizeButton && !sizeButton.disabled) {
      const panel = sizeButton.closest('.gm-product-card__quickadd');
      if (panel) GetmanQuickAdd.addToCart(sizeButton, panel);
    }
  }

  static setStepLabel(panel, step) {
    const label = panel.querySelector('.gm-product-card__quickadd-label');
    if (!label) return;
    const next = step === 'color' ? label.dataset.labelColor : label.dataset.labelSize;
    if (next) label.textContent = next;
  }

  static showColorStep(panel) {
    const colors = panel.querySelector('.gm-product-card__quickadd-colors');
    const sizes = panel.querySelector('.gm-product-card__quickadd-sizes');
    if (!colors || !sizes) return;

    colors.classList.remove('gm-product-card__quickadd-colors--hidden');
    sizes.classList.add('gm-product-card__quickadd-sizes--hidden');
    GetmanQuickAdd.setStepLabel(panel, 'color');
    GetmanQuickAdd.reconcileInventory(panel);
  }

  static loadCartQuantities(force) {
    if (!force && GetmanQuickAdd.cartQtyPromise) return GetmanQuickAdd.cartQtyPromise;
    GetmanQuickAdd.cartQtyPromise = fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        const map = new Map();
        (cart.items || []).forEach((line) => map.set(String(line.id), line.quantity));
        return map;
      })
      .catch(() => new Map());
    return GetmanQuickAdd.cartQtyPromise;
  }

  static reconcileInventory(panel) {
    const swatches = panel.querySelectorAll('.gm-size-swatch[data-inventory-max]');
    if (!swatches.length) return;

    GetmanQuickAdd.loadCartQuantities().then((qtyByVariant) => {
      swatches.forEach((swatch) => {
        const max = parseInt(swatch.dataset.inventoryMax, 10);
        if (Number.isNaN(max)) return;
        const inCart = qtyByVariant.get(String(swatch.dataset.variantId)) || 0;
        const maxed = inCart >= max;
        swatch.classList.toggle('gm-size-swatch--maxed', maxed);
        if (swatch.classList.contains('gm-size-swatch--soldout')) return;
        swatch.disabled = maxed;
        if (maxed) {
          swatch.title = (window.cartStrings && window.cartStrings.maxInCart) || 'Уже в кошику в максимальній доступній кількості';
        } else {
          swatch.removeAttribute('title');
        }
      });
    });
  }

  static showNote(panel, message) {
    let note = panel.querySelector('.gm-product-card__quickadd-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'gm-product-card__quickadd-note';
      note.setAttribute('role', 'status');
      const sizes = panel.querySelector('.gm-product-card__quickadd-sizes') || panel;
      sizes.appendChild(note);
    }
    note.textContent = message;
  }

  static selectColor(colorButton, panel) {
    const colorValue = colorButton.dataset.colorValue;

    panel.querySelectorAll('.gm-color-swatch').forEach((b) => {
      b.classList.toggle('gm-color-swatch--active', b === colorButton);
    });

    panel.querySelectorAll('.gm-size-swatch').forEach((sizeButton) => {
      sizeButton.classList.toggle('gm-size-swatch--hidden', sizeButton.dataset.colorValue !== colorValue);
    });

    const colors = panel.querySelector('.gm-product-card__quickadd-colors');
    const sizes = panel.querySelector('.gm-product-card__quickadd-sizes');
    if (colors) colors.classList.add('gm-product-card__quickadd-colors--hidden');
    if (sizes) {
      sizes.classList.remove('gm-product-card__quickadd-sizes--hidden');
      const firstSize = sizes.querySelector('.gm-size-swatch:not(.gm-size-swatch--hidden):not([disabled])');
      if (firstSize) firstSize.focus();
    }
    GetmanQuickAdd.setStepLabel(panel, 'size');
    GetmanQuickAdd.reconcileInventory(panel);
  }

  static onKeydown(event) {
    if (event.key !== 'Escape') return;
    const openPanel = document.querySelector('.gm-product-card__quickadd[open]');
    if (openPanel) GetmanQuickAdd.closePanel(openPanel);
  }

  static closePanel(panel) {
    const trigger = panel.querySelector('.gm-product-card__quickadd-trigger');
    panel.removeAttribute('open');
    if (trigger) trigger.focus();
  }

  static addToCart(button, panel) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;

    if (button.classList.contains('gm-size-swatch--maxed')) {
      GetmanQuickAdd.showNote(panel, (window.cartStrings && window.cartStrings.maxInCart) || 'Уже в кошику в максимальній доступній кількості');
      return;
    }

    if (GetmanQuickAdd.requestInFlight) return;
    GetmanQuickAdd.requestInFlight = true;

    const cart = document.querySelector('cart-drawer');

    button.setAttribute('aria-busy', 'true');
    const allButtons = panel.querySelectorAll('.gm-size-swatch');
    allButtons.forEach((b) => (b.disabled = true));

    const config = typeof fetchConfig === 'function' ? fetchConfig('json') : { method: 'POST', headers: { Accept: 'application/json' } };
    delete config.headers['Content-Type'];

    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (cart) {
      body.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      body.append('sections_url', window.location.pathname);
    }
    config.body = body;

    fetch(window.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {

          GetmanQuickAdd.showNote(
            panel,
            response.description || response.message || ((window.cartStrings && window.cartStrings.maxInCart) || 'Уже в кошику в максимальній доступній кількості')
          );
          button.classList.add('gm-size-swatch--maxed');
          GetmanQuickAdd.loadCartQuantities(true);
          GetmanQuickAdd.reconcileInventory(panel);
          return;
        }

        GetmanQuickAdd.closePanel(panel);

        if (cart) {

          cart.classList.remove('is-empty');
          cart.renderContents(response);
        }

        GetmanQuickAdd.refreshCartCount();

        GetmanQuickAdd.loadCartQuantities(true);
      })
      .catch((error) => {
        console.error('GETMAN quick add failed', error);
      })
      .finally(() => {
        GetmanQuickAdd.requestInFlight = false;
        button.removeAttribute('aria-busy');
        allButtons.forEach((b) => {
          if (b.classList.contains('gm-size-swatch--soldout') || b.classList.contains('gm-size-swatch--maxed')) return;
          b.disabled = false;
        });
      });
  }

  static refreshCartCount() {
    fetch(window.routes.cart_url + '.js')
      .then((response) => response.json())
      .then((cartState) => {
        const icon = document.getElementById('cart-icon-bubble');
        if (!icon) return;

        let bubble = icon.querySelector('.cart-count-bubble');

        if (cartState.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
            icon.appendChild(bubble);
          }
          const countEl = bubble.querySelector('[aria-hidden="true"]');
          if (countEl) countEl.textContent = cartState.item_count < 100 ? cartState.item_count : '';
        } else if (bubble) {
          bubble.remove();
        }
      })
      .catch((error) => console.error('GETMAN cart count refresh failed', error));
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', GetmanQuickAdd.init);
} else {
  GetmanQuickAdd.init();
}
